import dayjs from "dayjs"
import { IDateRange } from "../../../types/filter"

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export const toDateQuery = (dateRange: IDateRange) => ({
  fromDate: dayjs(dateRange.from).format("YYYY-MM-DD"),
  toDate: dayjs(dateRange.to).format("YYYY-MM-DD"),
})

export const formatHistoryDate = (value: string) =>
  dayjs.utc(value).tz(userTimezone).format("YYYY-MM-DD HH:mm")
